import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const TruckChristmas: FC<SvgIconProps> = ({ viewBox = '0 0 254 169', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#truck_christmas_paint2_clip)">
      <path
        opacity=".5"
        d="m78.4 153.6 118.8-22.9-43.3-24.1L35 129.5l43.4 24.1Z"
        fill="url(#truck_christmas_paint0_linear)"
      />
      <path
        d="M170.8 103.7c5.1-4.6 8.5-11 9.2-18.2.6-6-1.6-12-5.8-16.6-2.9-3.1-6.7-5.3-10.6-6-2.4-.5-4.6-.4-6.7.2-2.4.7-5.3 3.3-5.9 6.1-.4 2 .1 4.1 1.3 5.9 1.7 2.5 4.8 4.4 7.7 4.9 2.1.3 4.2 0 5.9-.9 1.7-.9 1.9-3.3.2-4.4-.8-.5-1.8-.6-2.6-.1-.8.4-1.7.6-2.7.4-1.3-.2-3.3-1.3-4.3-2.8-.7-1-.6-1.7-.5-2 .1-.6 1.4-1.9 2.2-2.2 1.3-.4 2.7-.4 4.3-.1 2.8.6 5.6 2.2 7.8 4.5 3.2 3.4 4.9 8.1 4.4 12.5-.9 10-8.2 18.1-18 20.1l-116 23.8c-1.4.3-2.3 1.6-2 3 .3 1.4 1.6 2.3 3 2l116.1-23.7c5-.9 9.4-3.2 13-6.4Z"
        fill="#333"
      />
      <path
        d="m171.4 73.7.5.5c3.2 3.4 4.9 8.1 4.4 12.5-.9 10-8.2 18.1-18 20.1L42.2 130.5c-1.4.3-2.3 1.6-2 3 0 .1 0 .1.1.2-.8-.3-1.4-1-1.6-1.9-.3-1.4.6-2.8 2-3l116.1-23.7c9.8-2 17.1-10.1 18-20.1.4-3.9-.9-8-3.4-11.3ZM165.1 64.6c-2.4-.5-4.6-.4-6.7.2-2.4.7-5.3 3.3-5.9 6.1-.4 2 .1 4.1 1.3 5.9l.1.1c-.6-.6-1.2-1.2-1.6-1.8-1.3-1.9-1.7-3.9-1.3-5.9.6-2.8 3.5-5.5 5.9-6.1 2.1-.6 4.4-.7 6.7-.2 3.9.8 7.7 2.9 10.6 6 .4.4.8.9 1.1 1.3-2.9-2.8-6.5-4.8-10.2-5.6Z"
        fill="#595959"
      />
      <path
        d="M163.6 74.6c.8-.4 1.8-.4 2.6.1.5.4.9.9 1 1.5-.7-.3-1.5-.3-2.2.1-.8.4-1.7.6-2.7.4-1.3-.2-3.3-1.3-4.3-2.8-.1-.1-.2-.3-.2-.4 1 .8 2.2 1.3 3.1 1.5 1 .2 1.9 0 2.7-.4ZM124.8 113.2c.6-.9.4-2.1-.5-2.7l-2.4-1.7c-7-4.9-11.9-12.1-13.8-20.4-.2-1-1.2-1.7-2.2-1.5-1.1.2-1.8 1.3-1.6 2.3 2.2 9.2 7.5 17.2 15.3 22.7l2.4 1.7c.9.7 2.1.5 2.8-.4Z"
        fill="#595959"
      />
      <path
        d="M123.6 113.9c.6-.9.4-2.1-.5-2.7l-2.4-1.7c-7-4.9-11.9-12.1-13.8-20.4-.2-1-1.2-1.7-2.2-1.5.3-.3.7-.6 1.1-.7 1-.2 2 .5 2.2 1.5 1.9 8.3 6.8 15.5 13.8 20.4l2.4 1.7c.9.6 1.1 1.8.5 2.7-.3.4-.8.7-1.2.8 0-.1.1-.1.1-.1Z"
        fill="#333"
      />
      <path
        d="M62.5 125.6c.6.9 1.9 1.2 2.7.5 7.3-5.5 11-14.7 9.6-23.8l-1.4-9c-.2-1-1.1-1.8-2.2-1.6h-.1c-1 .2-1.8 1.1-1.6 2.2l1.4 9c1.2 7.7-1.9 15.4-8.1 20.1-.6.6-.8 1.7-.3 2.6Z"
        fill="#595959"
      />
      <path
        d="M63.6 126c7.3-5.5 11-14.7 9.6-23.8l-1.4-9c-.1-.6-.4-1-.9-1.3.1 0 .2-.1.3-.1h.1c1-.2 2 .5 2.2 1.6l1.4 9c1.4 9.2-2.3 18.3-9.6 23.8-.6.5-1.5.5-2.1.1.1-.2.3-.2.4-.3ZM211.5 124.7c5.1-4.6 8.5-11 9.2-18.2.6-6-1.6-12-5.8-16.6-2.9-3.1-6.7-5.3-10.6-6-2.4-.5-4.6-.4-6.7.2-2.4.7-5.3 3.3-5.9 6.1-.4 2 .1 4.1 1.3 5.9 1.7 2.5 4.8 4.4 7.7 4.9 2.1.3 4.2 0 5.9-.9 1.7-.9 1.9-3.3.2-4.4-.8-.5-1.8-.6-2.6-.1-.8.4-1.7.6-2.7.4-1.3-.2-3.3-1.3-4.3-2.8-.7-1-.6-1.7-.5-2 .1-.6 1.4-1.9 2.2-2.2 1.3-.4 2.7-.4 4.3-.1 2.8.6 5.6 2.2 7.8 4.5 3.2 3.4 4.9 8.1 4.4 12.5-.9 10-8.2 18.1-18 20.1l-116 23.8c-1.4.3-2.3 1.6-2 3 .3 1.4 1.6 2.3 3 2l116.1-23.7c5-1 9.4-3.2 13-6.4Z"
        fill="#333"
      />
      <path
        d="m212.1 94.7.5.5c3.2 3.4 4.9 8.1 4.4 12.5-.9 10-8.2 18.1-18 20.1L82.9 151.5c-1.4.3-2.3 1.6-2 3 0 .1 0 .1.1.2-.8-.3-1.4-1-1.6-1.9-.3-1.4.6-2.8 2-3l116.1-23.7c9.8-2 17.1-10.1 18-20.1.4-3.9-.9-8-3.4-11.3ZM205.8 85.6c-2.4-.5-4.6-.4-6.7.2-2.4.7-5.3 3.3-5.9 6.1-.4 2 .1 4.1 1.3 5.9l.1.1c-.6-.6-1.2-1.2-1.6-1.8-1.3-1.9-1.7-3.9-1.3-5.9.6-2.8 3.5-5.5 5.9-6.1 2.1-.6 4.4-.7 6.7-.2 3.9.8 7.7 2.9 10.6 6 .4.4.8.9 1.1 1.3-2.9-2.9-6.5-4.9-10.2-5.6Z"
        fill="#595959"
      />
      <path
        d="M204.3 95.6c.8-.4 1.8-.4 2.6.1.5.4.9.9 1 1.5-.7-.3-1.5-.3-2.2.1-.8.4-1.7.6-2.7.4-1.3-.2-3.3-1.3-4.3-2.8-.1-.1-.2-.3-.2-.4 1 .8 2.2 1.3 3.1 1.5.9.1 1.9 0 2.7-.4ZM165.4 134.1c.6-.9.4-2.1-.5-2.7l-2.4-1.7c-7-4.9-11.9-12.1-13.8-20.4-.2-1-1.2-1.7-2.2-1.5-1.1.2-1.8 1.3-1.6 2.3 2.2 9.2 7.5 17.2 15.3 22.7l2.4 1.7c1 .7 2.2.5 2.8-.4Z"
        fill="#595959"
      />
      <path
        d="M164.3 134.8c.6-.9.4-2.1-.5-2.7l-2.4-1.7c-7-4.9-11.9-12.1-13.8-20.4-.2-1-1.2-1.7-2.2-1.5.3-.3.7-.6 1.1-.7 1-.2 2 .5 2.2 1.5 1.9 8.3 6.8 15.5 13.8 20.4l2.4 1.7c.9.6 1.1 1.8.5 2.7-.3.4-.8.7-1.2.8l.1-.1Z"
        fill="#333"
      />
      <path
        d="M103.2 146.6c.6.9 1.9 1.2 2.7.5 7.3-5.5 11-14.7 9.6-23.8l-1.4-9c-.2-1-1.1-1.8-2.2-1.6h-.1c-1 .2-1.8 1.1-1.6 2.2l1.4 9c1.2 7.7-1.9 15.4-8.1 20.1-.6.6-.9 1.7-.3 2.6Z"
        fill="#595959"
      />
      <path
        d="M104.3 146.9c7.3-5.5 11-14.7 9.6-23.8l-1.4-9c-.1-.6-.4-1-.9-1.3.1 0 .2-.1.3-.1h.1c1-.2 2 .5 2.2 1.6l1.4 9c1.4 9.2-2.3 18.3-9.6 23.8-.6.5-1.5.5-2.1.1.1-.1.2-.2.4-.3Z"
        fill="#333"
      />
      <path d="M95.5 117.1 176 99.8l-39.4-20.6-80.4 17.2 39.3 20.7Z" fill="#980000" />
      <path d="m182 57.5-38-21.6-9.4 45.1 32.7 27.8L182 57.5Z" fill="#980000" />
      <path
        d="m141.7 35.3-4 .8c-3.2.6-5.7 3.2-6.2 6.4-1 6.5-2.8 16.9-4.7 19.4-5.8 7.6-28.5 7.1-38 5.9-14.4-1.9-32.5-15.9-32.5-15.9v46.7c2.8.2 4.5 1.9 5.1 4.1L122 90.9c13.4-2.6 23-14.3 23-27.9V38.1c0-1.8-1.6-3.1-3.3-2.8Z"
        fill="#D40511"
      />
      <path
        opacity=".3"
        d="M155.6 94.7c-15.7-2.9-20.5-10.1-20.5-10.1-2.1-.1-3.9-.3-5.4-.5-13.1-1.7-29.4-13.5-32.1-15.6h-.4v27.3l12.9-2.5 5.9 8 39.6-6.6Z"
        fill="#000"
      />
      <path opacity=".5" d="m145 98.9 7.1-1.5L140 91l-7.1 1.5 12.1 6.4Z" fill="url(#truck_christmas_paint1_linear)" />
      <path d="m138.4 73.3 17.5-3-10-4.9-17.5 3.1 10 4.8Z" fill="#FDDE84" />
      <path d="M138.4 73.3V95l-10-4.9V68.5l10 4.8Z" fill="#C39000" />
      <path d="M138.4 73.3v18.1l17.5-3.1V70.2l-17.5 3.1Z" fill="#FCCE09" />
      <path d="m133.7 92.1-1.5-.7-.1-21.2 1.6.8v21.1Z" fill="#980000" />
      <path d="m150 67.3-17.9 2.9 1.6.8 17.8-2.9-1.5-.8Z" fill="#D2002E" />
      <path d="m147 87.2 1.8-.3.1-15.4-1.9.3v15.4Z" fill="#AF0527" />
      <path d="m138.9 66.6 10.1 4.8-1.9.3-9.9-4.8 1.7-.3Z" fill="#D2002E" />
      <path d="M141.5 68.8s-3.6-.2-4.6-.3c-1-.1-1.4.4-1.4 1 0 .5.5.9.9 1.1l2.5 1.5 4-2.4-1.4-.9Z" fill="#D2002E" />
      <path d="M142.9 69.6s-1.8.3-2.8.5c-.9.2-1.8.4-1.6 1.4.2 1 1.4.6 2 .2.5-.6 2.4-2.1 2.4-2.1Z" fill="#AF0527" />
      <path d="M141.9 68.7s1.1-2.6 1.3-3.2c.2-.6.7-1.2 1.4-1 .7.2 3.5 1.7 3.5 1.7l-4.9 3.2-1.3-.7Z" fill="#D2002E" />
      <path
        d="M143.2 69.5s2.8-2.4 3.2-2.7c.4-.3 1.8-1 1.8-.2s-.6 1.1-1.5 1.5c-.8.4-3.5 1.4-3.5 1.4ZM137.3 68.8l4.3.2.5.5-3 .6 2.2-.7-1.4-.1 1.1-.2-3.7-.3ZM142.4 68.6l1.2-2.6-.8 2.3.5-.6-.2.7s.8-1 .8-.9l-.6 1.1 2.3-1.7-2.5 2.2-.7-.5Z"
        fill="#AF0527"
      />
      <path d="M143.2 68.7c.5.2.5.7 0 .9-.5.2-1.2.2-1.6 0-.4-.2-.5-.7 0-.9.4-.3 1.2-.3 1.6 0Z" fill="#D2002E" />
      <path
        d="M143.3 69.4c-.5.2-1.2.2-1.6 0-.3-.2-.4-.4-.3-.6-.2.2-.2.5.2.8.5.2 1.2.2 1.6 0 .2-.1.2-.2.3-.3 0 0-.1 0-.2.1Z"
        fill="#AF0527"
      />
      <path d="m152.1 77.2 21.2-4-12.1-6.4-21.2 4.1 12.1 6.3Z" fill="#FDDE84" />
      <path d="M152.1 77.2v20.2L140 91V70.9l12.1 6.3Z" fill="#C39000" />
      <path d="M152.1 77.2v20.2l21.2-4.1V73.2l-21.2 4Z" fill="#FCCE09" />
      <path d="m146.4 94.4-1.8-1-.1-20.2 2 1-.1 20.2Z" fill="#980000" />
      <path d="m166.1 69.4-21.7 3.8 2 1 21.6-3.8-1.9-1Z" fill="#D2002E" />
      <path d="m162.5 95.4 2.2-.4.1-20.2-2.4.4v20.2h.1Z" fill="#AF0527" />
      <path d="m152.6 68.5 12.2 6.3-2.4.4-12-6.3 2.2-.4Z" fill="#D2002E" />
      <path
        d="M155.8 71.3s-4.4-.3-5.6-.4c-1.2-.1-1.7.6-1.7 1.3 0 .6.6 1.1 1.1 1.4.6.4 3.1 2 3.1 2l4.8-3.2-1.7-1.1Z"
        fill="#D2002E"
      />
      <path d="M157.5 72.4s-2.2.4-3.3.7c-1.1.2-2.2.5-2 1.8.2 1.3 1.6.8 2.4.2.6-.7 2.9-2.7 2.9-2.7Z" fill="#AF0527" />
      <path d="M156.3 71.2s1.3-3.3 1.6-4.1c.3-.8.9-1.6 1.6-1.3.7.3 4.3 2.2 4.3 2.2l-5.9 4.2-1.6-1Z" fill="#D2002E" />
      <path
        d="M157.8 72.2s3.3-3.1 3.8-3.6 2.1-1.4 2.2-.3c.1 1.1-.8 1.4-1.8 2-.9.6-4.2 1.9-4.2 1.9ZM150.7 71.3l5.2.2.6.7-3.6.8 2.6-.9-1.7-.1 1.4-.3-4.5-.4ZM156.9 71l1.4-3.3-.9 3 .6-.8-.3.9s1-1.3 1-1.2L158 71l2.8-2.3-3.1 2.8-.8-.5Z"
        fill="#AF0527"
      />
      <path d="M157.9 71.2c.6.3.6.9 0 1.1-.6.3-1.4.3-2 0-.6-.3-.6-.9 0-1.1.6-.4 1.5-.4 2 0Z" fill="#D2002E" />
      <path
        d="M158 72.1c-.6.3-1.4.3-2 0-.4-.2-.5-.5-.4-.8-.3.3-.2.7.2 1 .6.3 1.4.3 2 0 .2-.1.3-.2.4-.4.1.1 0 .1-.2.2Z"
        fill="#AF0527"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.9 73.7c-.8 3.7 1.8 6.7 2.3 8.8l.9 3.6 8.4 12.1c2.5 1.7 7.6-1.9 6.6-4.3L128.6 75c-1.9-4.4-6.9-2.1-8.7-1.3Z"
        fill="#25232B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m140.2 98.8-3 2.4c.1 2.8.1 4.2 1.3 4.9 1.4.9 3.6.1 4.9-.6l.3-1.1c1.8-.3 1.4 0 3.2-1.1 2.2-1.3 4.9-3.2 5.2-5.3.1-.6-.4-1.7-1-1.6l-6.7 1.3-4.2 1.1Z"
        fill="#08355C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M137.6 105.1c.2.5.4.8.9 1.1 1.4.9 3.6.1 4.9-.6l.3-1.1c1.8-.3 1.4 0 3.2-1.1 2.2-1.3 4.9-3.2 5.2-5.3.1-.4-.2-1.1-.5-1.4.1.2.1.4.1.6-.4 2.1-3 4-5.2 5.3-1.8 1.1-1.3.8-3.2 1.1l-.3 1.1c-1.3.7-3.6 1.4-4.9.6-.3-.1-.4-.2-.5-.3Z"
        fill="#D0DBDF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M125.6 77.2c-.8 3.7 1.8 6.7 2.3 8.8l.9 3.6 8.4 12.1c2.5 1.7 7.6-1.9 6.6-4.3l-9.4-18.9c-2-4.3-6.9-2-8.8-1.3Z"
        fill="#33303B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.7 92c4.1-.9 11.5-7.3 16.3-10.7l4.2-2.2c.3-4.4 0-5.8-2.1-6.5-3.8-1.3-15.1 3.9-20.1 6.3l1.7 13.1Z"
        fill="#25232B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m100 80.4-2.7 1.4c-1 4.3-.4 7.4 1.6 9.5 2.9 3 8.8 5.3 14.4 4 4.1-.9 11.5-7.3 16.3-10.7l4.2-2.2c.3-4.4 0-5.8-2.1-6.5-4.1-1.3-14.6 4.1-19.6 6.6L100 80.4Z"
        fill="#33303B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.9 49c-5 7.3 3.1 23.8 5.4 28.7 2.9 6 20 8.2 17.9-.4-4.3-10.5-2.6-12.4-3.4-19.4-.2-2.3-.4-3.5-1.7-4.9-2.4-2.5-15.6-7.7-18.2-4Z"
        fill="#FFCC13"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119 75.9c2-.4 2.2-.6 4.2-1.8.8-.4 1.1-.6 2.4-.8 1.1-.1 3.2 1.3 5.2 1.8 1.3.4 1.3 1.5 1 2.1-.4 1.2-2.1 1.2-3.5 1.6-1.2.4-1.8.6-3.3.7-1 0-2.1-.2-3.1-.2l-2.8-.1-.1-3.3h.1-.1Z"
        fill="#F2A784"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m109.3 72.3 12.3 2.7c.6.8.8 3.2-.3 4.7-1.5 0-14.3-.9-18.6-2-2-.5-2.2-1.4-1.8-3.4.7-3.4 5-2.7 8.4-2Z"
        fill="#201D19"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.9 58c.2 3.4-.4 8.3-.6 12.5-.5 4.3.3 7-4 7.1-2 .2-2.5-.6-2.8-2.6l-1.8-12.9c-.1-4.8 2.1-8.6 4.3-9.6 2.3-.8 4.6.9 4.9 5.5Z"
        fill="#201D19"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.5 41.9c1.3 4.3 1.4 4.1 1.2 7.4-.1 2.2 6.2 1.7 6.2-.2-.6-3.8-.1-5.6.5-11.2l-7.9 4Z"
        fill="#D98D6C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.8 33.9c.8 1.2 1.3 2.1 1.4 3.7.1 1.3.1 3.2.1 4.5 0 1.1.2 5-.6 5.5-.6.4-3.8-.3-5-1.4-.9-.7-.5-3.1-.9-3.5l1.2-8.1 3.8-.7Z"
        fill="#F2A784"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.3 33.3c-2.9 2.5-2.6 6.5-.5 9.4.9 1.3 1.5 2.2 2 4.7 2.3.5 3.4-.1 4.7-2.5 1.3-2.3.7-4.6 1.9-4.9.5-.1 1 .5 1.1 2.5.6-2.1.6-4.7 1.7-6.4.5-.8.7-1.6.6-2.7-1.2 0-2.2-1.2-3.7-1.6-2.9-.7-6.4-.6-7.8 1.5Z"
        fill="#331202"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.7 48c.3 1.8 4.5 1.8 6.2.3l.7 1.3c-1.2 2.6-6.8 3.4-7.2.6l.3-2.2Z"
        fill="#E4291C"
      />
      <path
        d="m100.2 32-.6-.7c-.4-.5-2.1-1.2-2.1-1.2-4.2-1.3-7.4 0-8 .1l1 .2c-.8.1 2.2-.1 1.5.3l-1.1.5c-.9.4-1.6 1-2.3 1.7l-.3.3c-.5.5-.8 1.1-1 1.8-.1.4-.2.9-.1 1.3v.2c0 .5.1.9.2 1.3l.4 1.4 12.4-7.2Z"
        fill="#D20612"
      />
      <path
        d="m87.5 43.7-.8 4.2-.5 2.4c0 .2-.2.4-.3.6-.2.2-.4.3-.6.3-.2 0-.5 0-.7-.1-.2-.1-.4-.3-.4-.5 0-.1-.1-.1-.1-.2l-.8-3.2c-.5-2.2-.8-4.5-.8-6.8 0-1.7.3-3.3.9-4.9.6-1.7 1.7-3.2 3.1-4.3l.1-.1.3-.2.1-.1c1.4-.6 2.9-1 4.4-1.1h1.7l2.7.5h.2l3.3 1c.1 0 .2.1.2.2.1.1.1.2.1.3 0 .1 0 .2-.1.3 0 .1-.1.2-.2.2l-.5.3.2.1-4 2.8-.2.2-5.1 3.4s-1.2.4-1.3.4h-.3"
        fill="#D40511"
      />
      <path
        d="m99.8 31.7-12.1 6.6c-.2.1-.3.4-.2.6l.4.8c.1.2.4.3.6.2l12.1-6.6c.2-.1.3-.4.2-.6l-.4-.8c-.1-.2-.4-.3-.6-.2Z"
        fill="#fff"
      />
      <path
        d="M88.3 38.7c.2.1.4.1.6.1.2 0 .5-.1.7-.3l.1-.1c.1-.1.1-.1.2-.1l.6-.3c.1-.1.3-.1.5-.1h.3c.3 0 .5-.1.7-.3l.5-.4 1-.8c.2-.1.4-.2.7-.3h.3c.3 0 .5-.1.7-.3l.9-.7c.1-.1.2-.2.4-.2l.5-.2 1.3-.6c.1 0 .2-.1.3-.1l.7-.5c.1-.1.2-.1.3-.2l.3-.1.1-.1.7-.4.1.2v.2l-.1.2-.6.3-7.3 4-4.4 2.4-.2.1H88l-.2-.1-.1-.1-.2-.4-.2-.4"
        fill="#EBEBEC"
      />
      <path
        opacity=".4"
        d="m87.7 38.3-.4.3-.4-1c-.5-.7-.7-1.4-.6-2.2l.1-.8.1-.3c.2-.5.4-1 .8-1.3l.2-.2c.1-.1.2-.2.4-.2.1 0 .1 0 .2.1.1 0 .1.1.1.2l.3.7c.1.2.1.3.1.5s-.1.3-.1.5l-.5.9c-.1.2-.1.5-.1.7l.1.2c0 .1.1.3.3.4l1 .8-1.6.7Z"
        fill="#90191C"
      />
      <path opacity=".4" d="m86.7 47.9.6-3 .5-2.1.2-3.2-.8-1.5-.5-1-.6 13.3.6-2.5Z" fill="#90191C" />
      <path
        d="M86.9 51c.1.3 0 .6-.1.9-.1.3-.3.5-.6.7-.3.2-.6.2-.9.2-.3 0-.6-.1-.9-.3-.2-.2-.4-.4-.5-.7-.1-.3-.1-.6 0-.9.1-.3.3-.6.5-.8.2-.2.5-.3.8-.4h.6c.2 0 .4.1.5.3.2.1.3.3.4.4.1.2.1.4.2.6Z"
        fill="#EBEBEC"
      />
      <path
        d="M86.7 50.5c-.1-.3-.4-.5-.6-.6-.3-.1-.6-.2-.9-.2-.4 0-.7.2-1 .5-.3.3-.4.6-.4 1 .2-.2.4-.4.6-.3.1.1.2-.2.4-.4.2-.1.5-.1.8-.1.1-.1.2-.2.3-.2.1 0 .2 0 .3.1.1.2.3.2.5.2Z"
        fill="#fff"
      />
      <path d="M98.3 73.2v47.7L59 100.2V50.5c0-7.2 7.6-11.8 14-8.5l9.6 5c9.6 5.1 15.7 15.2 15.7 26.2Z" fill="#FA3944" />
      <path
        d="M95.2 74.3v47.6l-39.4-20.7V51.6c0-7.2 7.6-11.8 14-8.5l9.6 5c9.7 5.2 15.8 15.2 15.8 26.2Z"
        fill="#980000"
      />
      <path d="m98.9 125-2.7-.8-40.4-23 43.5 10.7-.4 13.1Z" fill="#980000" />
      <path
        d="M95.2 74v47.9c0 2 1.8 3.5 3.8 3.1l62-12c13.4-2.6 23-14.3 23-27.9V60.2c0-1.8-1.6-3.1-3.4-2.8l-4 .8c-3.2.6-5.7 3.2-6.2 6.4-1 6.5-2.8 16.9-4.7 19.4-5.8 7.6-28.5 7.1-38 5.9C113.3 88 95.2 74 95.2 74Z"
        fill="#D40511"
      />
      <path
        d="M144 35.9c-.6-.5-1.5-.8-2.4-.6l-3.2.6 4.9 2.8 1.6.9L177.3 58l3.3-.6c.5-.1.9 0 1.4.1l-38-21.6Z"
        fill="#FA3944"
      />
      <path d="M101.1 40.8s1.9 2.7.4 2.7c-1.5-.1-.4-2.7-.4-2.7Z" fill="#F2A784" />
    </g>
    <defs>
      <linearGradient
        id="truck_christmas_paint0_linear"
        x1="86.665"
        y1="162.956"
        x2="147.628"
        y2="94.854"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0" />
        <stop offset=".273" stopOpacity=".6" />
        <stop offset=".52" stopOpacity=".8" />
        <stop offset=".768" stopOpacity=".6" />
        <stop offset=".981" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="truck_christmas_paint1_linear"
        x1="141.611"
        y1="96.748"
        x2="143.73"
        y2="92.489"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".25" stopOpacity="0" />
        <stop offset=".599" stopOpacity=".3" />
        <stop offset="1" stopOpacity=".8" />
      </linearGradient>
      <clipPath id="truck_christmas_paint2_clip">
        <path fill="#fff" d="M0 0h254v180H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
)
